import { getCDNpath } from '../../../app/common/util';

const visa = getCDNpath('/static/images/cards/visa.png');
const vi = getCDNpath('/static/images/cards/visa.png');
const mastercard = getCDNpath('/static/images/cards/mastercard.png');
const amex = getCDNpath('/static/images/cards/amex.png');
const discover = getCDNpath('/static/images/cards/discover.png');
const maestro = getCDNpath('/static/images/cards/maestro.png');
const paypal = getCDNpath('/static/images/cards/paypal.png');
const rupay = getCDNpath('/static/images/cards/rupay.png');
const diner = getCDNpath('/static/images/cards/diner.png');
const diners = getCDNpath('/static/images/cards/diners.png');
const dinr = getCDNpath('/static/images/cards/dinr.png');
const dinrs = getCDNpath('/static/images/cards/dinrs.png');

export  { visa, vi, mastercard, amex, discover, maestro, paypal, rupay, diner, diners, dinr, dinrs };